import {Platform, StyleSheet} from 'react-native';

import {variants} from '/component/base/Text/Text.style';
import {indent} from '/constant/layout.constant';
import {black, cloudLight, onyxLight, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  content: {
    flex: 1,
    backgroundColor: white,
    paddingTop: indent,
    paddingRight: indent,
    paddingLeft: indent,
  },
  successModalContainer: {
    flex: 1,
    alignItems: 'center',
    marginTop: indent * 13,
    justifyContent: 'space-around',
    marginBottom: indent * 13,
  },
  spacer: {
    marginVertical: indent * 1.5,
  },
  successContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  successText: {
    fontWeight: '900',
    fontSize: indent,
    marginLeft: indent - 10,
    color: black,
  },
  horizontalRule: {
    backgroundColor: cloudLight,
    height: 2,
    width: indent * 15,
  },
  thankYouText: {
    ...variants.small,
    fontWeight: '500',
    color: onyxLight,
    textAlign: 'center',
    paddingRight: indent,
    paddingLeft: indent,
  },
  thankYouText2: {
    ...variants.small,
    fontWeight: '500',
    color: onyxLight,
    textAlign: 'center',
    paddingRight: indent,
    paddingLeft: indent,
  },
  doneButton: {
    fontWeight: '900',
    color: black,
    fontSize: indent - 4,
  },
  itemIcon: {
    fontSize: 24,
    color: onyxLight,
    marginBottom: 4,
  },
  logoStyle: {
    width: '100%',
  },
  // added for logo
  logoContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  logoIcon: {
    width: 90,
    height: 90,
    marginBottom: 12,
  },

  optaviaText: {
    flexDirection: 'row',
    paddingTop: 6,
    paddingBottom: Platform.select({android: 4, ios: 0}),
  },

  optaviaBold: {
    fontSize: 34,
    lineHeight: 38,
    fontWeight: '500',
    letterSpacing: 1,
    color: '#000000',
  },

  optaviaRegular: {
    fontSize: 34,
    lineHeight: 38,
    fontWeight: '300',
    letterSpacing: 1,
    color: '#000000',
  },

  coachText: {
    paddingTop: Platform.select({android: 1, ios: 7}),
    fontSize: 28,
    fontWeight: '200',
    letterSpacing: 3,
    color: '#000000',
    marginTop: Platform.select({android: 0, ios: 4}),
  },
  registered: {
    fontSize: 8,
    fontWeight: '400',
    marginLeft: 2,
    lineHeight: 22,
    textAlignVertical: 'top',
  },
});
